/**
 * 名前入力ステップ
 */
import { useState, ChangeEventHandler } from "react";
import { isIos } from "common/utils";
import I18n from "features/shared/i18n";
import { CreatePlayerState } from "../types";

interface PlayerNameInputStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
}

export const PlayerNameInputStep = ({ state, updateState }: PlayerNameInputStepProps) => {
  const [error, setError] = useState("");

  const handleNameChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = e.target.value;
    if (value.length > 10) {
      setError(I18n.t("MSG_USER_NAME_LENGTH_LIMIT"));
    } else {
      if (error) setError("");
    }
    updateState({ name: value });
  };

  return (
    <div className="flex-col-el flex-center w-full h-full py-8">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[24px]">
          {I18n.t("MSG_USER_PROFILE_INPUT_NAME_PROMPT_BY_PARENT")}
        </p>
      </div>

      {/* 名前入力フィールド */}
      <div className="flex-col-el w-[400px] relative">
        <input
          type="text"
          value={state.name}
          autoFocus={!isIos()}
          onChange={handleNameChange}
          placeholder={I18n.t("MSG_USER_PROFILE_NAME_PLACEHOLDER_BY_PARENT")}
          className={`input-modal text-body text-textcolor-black text-[26px] text-center ${
            error ? "!border-danger" : ""
          }`}
        />
        <div className="flex-row-el justify-between mt-2">
          <label className="text-body text-left text-[14px] h-5 text-danger">{error || ""}</label>
          <label className="text-body text-right text-[14px] h-5 text-gray2-80">
            {I18n.t("MSG_BLOCKLY_INPUT_LENGTH_LIMIT_BY_PARENT", { limit: 10 })}
          </label>
        </div>
      </div>
    </div>
  );
};
